export const OPEN_COUNTER = "O";
export const STOP_COUNTER = "S";